module.exports = __webpack_public_path__ + "img/ico-survey-conclusion.274aae9e.svg";